import React, { Component } from 'react';
import Responsive from 'react-responsive';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'; // ES6

import SeDropdownItemsList from './SeDropdownItemsList';
import SeDropdownContentMobileHeader from './SeDropdownContentMobileHeader';
import styles from './index.scss';

import SeDropdownSearchInput from './SeDropdownSearchInput';

import { DDGroupContext } from '../SeDropdownGroup';
import { DD_SEARCH_THRESHOLD } from '../../../config/consts';

let idCounter = 0;
const Phones = props => <Responsive {...props} maxWidth={400} />;
function getUniqueId() {
    return `se-dd-${idCounter++}`;
}

class SeDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            items: [],
            normalizedItems: [],
            searchValue: '',
            filteredItems: [],
        };

        this.toggleOpen = this.toggleOpen.bind(this);
    }

    /**
     * SeDropdown can accept to types of items arrays
     * array of strings and array of objects { text: String, value: Any }
     */
    static normalizeItems(items) {
        if (items.length && typeof items[0] === 'string') {
            return items.map(str => ({ text: str, value: str }));
        }
        return items;
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let newState = null;
        if (typeof nextProps.open === 'boolean' && prevState.open !== nextProps.open) {
            newState = newState || {};
            newState.open = nextProps.open;
        }
        if (nextProps.items !== prevState.items) {
            newState = newState || {};
            newState.items = nextProps.items;
            newState.normalizedItems = SeDropdown.normalizeItems(nextProps.items);
        }
        return newState;
    }

    toggleOpen() {
        const { isLoading, disabled, ddId, onOpen } = this.props;
        if (isLoading || disabled) {
            return;
        }
        // if dropdown open state is managed by the DD group
        if (ddId) {
            onOpen(ddId, this.state.open);
        } else {
            this.setState({
                open: !this.state.open,
            });
        }
    }

    handleClose = () => {
        this.setState({
            searchValue: '',
        });
        this.toggleOpen();
    };

    handleSearchChange = value => {
        this.setState({
            searchValue: value,
        });
    };

    handleSelectOption = val => {
        this.setState({
            searchValue: '',
        });
        this.toggleOpen();
        if (this.props.value !== val) {
            this.props.onChange(val);
        }
    };

    renderDDElement(extraClass) {
        const { open, searchValue, normalizedItems } = this.state;
        const {
            value,
            placeholder,
            searchPlaceholder,
            isLoading,
            disabled,
            formatItemText,
            showSearch,
            showSearchThreshold,
        } = this.props;

        const ddElementClasses = classNames({
            [styles.ddElementDisabled]: isLoading || disabled,
            [styles.ddElement]: true,
            'se-dropdown-element': true,
            [styles.ddElementOpen]: this.state.open,
            [extraClass]: !!extraClass,
        });

        const ddBtnToggle = classNames({
            [styles.ddBtn]: true,
            [styles.ddBtnToggle]: true,
            [styles.ddBtnToggle_up]: open,
        });
        let ddInputText = '';
        let dropdownText = '';

        const selectedItem = value && normalizedItems.find(itm => itm.value === value);

        if (selectedItem) {
            dropdownText = formatItemText(selectedItem.text);
            ddInputText = classNames({
                [styles.ddElementItem]: true,
                [styles.ddElementItem_filled]: true,
            });
        } else {
            dropdownText = this.props.intl.formatMessage({
                id: placeholder,
            });
            ddInputText = classNames({
                [styles.ddElementItem]: true,
                [styles.ddElemetnItem_filled]: false,
            });
            // isPlaceholder = true;
        }

        const loaderClass = classNames({
            [styles.ddElementLoader]: true,
        });

        const searchEnabled = showSearch && normalizedItems.length > showSearchThreshold;

        return (
            <div className={ddElementClasses} onClick={this.handleClose}>
                <Phones>
                    {isPhone => {
                        if (open && searchEnabled && !isPhone) {
                            return (
                                <SeDropdownSearchInput
                                    onChange={this.handleSearchChange}
                                    onClose={this.handleClose}
                                    value={searchValue}
                                    className={styles.ddSearchField}
                                    searchPlaceholder={searchPlaceholder}
                                />
                            );
                        }
                        return <div className={ddInputText}>{dropdownText}</div>;
                    }}
                </Phones>
                {isLoading ? (
                    <button className={styles.ddBtn}>
                        <div className={loaderClass} />
                    </button>
                ) : (
                    <button className={ddBtnToggle} />
                )}
            </div>
        );
    }
    renderContent() {
        const { open, searchValue, normalizedItems } = this.state;
        const { showSearch, showSearchThreshold, excludeFromSearch, dropdownHeight, infoBlockHeight } = this.props;

        const searchEnabled = showSearch && normalizedItems.length > showSearchThreshold;

        const contentClass = classNames({
            [styles.ddContent]: true,
            [styles.noSearch]: !searchEnabled,
        });

        return (
            <React.Fragment>
                <Phones>
                    {isPhone => (
                        <ReactCSSTransitionGroup
                            component="div"
                            className={styles.animatedContentWrapper}
                            transitionName="seddcontent"
                            transitionEnter={isPhone}
                            transitionLeave={isPhone}
                            transitionEnterTimeout={500}
                            transitionLeaveTimeout={500}
                        >
                            {open ? (
                                <div className={contentClass}>
                                    <Phones>
                                        <SeDropdownContentMobileHeader
                                            onClose={this.handleClose}
                                            onSearchChange={this.handleSearchChange}
                                            searchValue={this.state.searchValue}
                                            searchPlaceholder={this.props.searchPlaceholder}
                                            searchEnabled={searchEnabled}
                                        />
                                    </Phones>
                                    <SeDropdownItemsList
                                        searchValue={searchValue}
                                        value={this.props.value}
                                        items={normalizedItems}
                                        excludeFromSearch={excludeFromSearch}
                                        formatItemText={this.props.formatItemText}
                                        onSelect={this.handleSelectOption}
                                        infoBlock={this.props.infoBlock}
                                        dropdownHeight={dropdownHeight}
                                        infoBlockHeight={infoBlockHeight}
                                        withoutSorting={this.props.withoutSorting}
                                    />
                                </div>
                            ) : null}
                        </ReactCSSTransitionGroup>
                    )}
                </Phones>
                <Phones>
                    <ReactCSSTransitionGroup
                        transitionName="sedd-animated-overlay"
                        transitionEnterTimeout={500}
                        transitionLeaveTimeout={500}
                    >
                        {open ? <div className={styles.overlay} /> : null}
                    </ReactCSSTransitionGroup>
                </Phones>
            </React.Fragment>
        );
    }
    render() {
        const { extraClass } = this.props;
        const wrapperClasses = classNames({
            'se-dropdown': true,
            [styles.ddWrap]: true,
            [extraClass]: !!extraClass,
        });
        return (
            <div className={wrapperClasses}>
                {this.renderDDElement(extraClass)}
                {this.renderContent()}
            </div>
        );
    }
}

SeDropdown.propTypes = {
    dropdownHeight: PropTypes.number,
    showSearch: PropTypes.bool,
    items: PropTypes.array.isRequired,
    formatItemText: PropTypes.func,
    excludeFromSearch: PropTypes.array,
    value: PropTypes.string.isRequired,
    showSearchThreshold: PropTypes.number, // used only when showSearch = true,  was: visibleSearchFieldLimit
    extraClass: PropTypes.string,
    isLoading: PropTypes.bool,
    disabled: PropTypes.bool,

    onChange: PropTypes.func.isRequired,

    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired,
    }),

    infoBlock: PropTypes.element,
    infoBlockHeight: PropTypes.number,
    placeholder: PropTypes.string,
    searchPlaceholder: PropTypes.string,

    onOpen: PropTypes.func,
    ddId: PropTypes.string,
    open: PropTypes.bool,
    withoutSorting: PropTypes.bool,
};

SeDropdown.defaultProps = {
    dropdownHeight: 230,
    showSearch: true, // true means - auto, false - trun off
    formatItemText: str => str,
    showSearchThreshold: DD_SEARCH_THRESHOLD,
    infoBlock: null,
    infoBlockHeight: 56,
    excludeFromSearch: [],
    isLoading: false,
    disabled: false,
    extraClass: '',

    placeholder: '',
    searchPlaceholder: 'tradeUps_typeOrSelect',

    // Special props for group-connected dropdowns
    onOpen: () => {},
    ddId: '',
    open: null,
    withoutSorting: false,
};

SeDropdown = injectIntl(SeDropdown); // eslint-disable-line

export default SeDropdown;

export class SeDropdownGrouped extends Component {
    constructor(props) {
        super(props);
        this.ddId = getUniqueId();
    }
    render() {
        return (
            <DDGroupContext.Consumer>
                {context => <SeDropdown {...this.props} {...context.getDDProps(this.ddId)} />}
            </DDGroupContext.Consumer>
        );
    }
}
